import React from "react";
const shopContext = React.createContext();
export default shopContext;
